module.exports = __webpack_public_path__ + "img/hr-car-1.08ba9f41.png";